const uniqueDomainsCounterSession = require('./unique-domains-counter-session')
const secondsOnPageSession = require('./seconds-on-page-session')

module.exports = {
  uniqueDomainsCounterSession,
  secondsOnPageSession
}
